// Which folded sections are open on a page, kept in settings so a page opens the way the user left it, on any
// device (Craig, 23 Oct 2026: "collapse all the sections by default, but remember the user's last state").
// Stored as settings.openSections: { [page]: [section ids] }. A section not listed is closed.
export const OPEN_PAGES = { TODAY: "today", RADAR: "radar" };
export const INSPIRATION = "inspiration";

export const isOpen = (settings, page, id) => (settings?.openSections?.[page] || []).includes(id);

export const toggleOpen = (settings, page, id) => {
  const open = settings?.openSections?.[page] || [];
  const next = open.includes(id) ? open.filter(x => x !== id) : [...open, id];
  return { ...settings, openSections: { ...settings?.openSections, [page]: next } };
};

// What to merge into the settings document for one toggle: that page's list and nothing else, so a tap never
// writes back other settings from an older copy (the payment server changes some of them).
export const openSectionsPatch = (settings, page) => ({ openSections: { [page]: settings?.openSections?.[page] || [] } });
